import { CheckIcon, XIcon } from 'lucide-react'

interface AuthFlagProps {
  value?: boolean | null
  label: string
}

export function AuthFlag({ value, label }: AuthFlagProps) {
  return (
    <div className="flex items-center gap-2">
      {value ? (
        <CheckIcon className="size-4 text-green-600" aria-hidden />
      ) : (
        <XIcon className="size-4 text-red-600" aria-hidden />
      )}
      <span className="text-sm">{label}</span>
    </div>
  )
}
